import { Select } from "antd";
import { useEffect } from "react";

export default function CrrMultiselect(props) {
  const {
    qnId = "", // to check if the page using the component is pre-assessment
    selectField,
    placeholderText,
    onChange,
    options,
    disabled,
    setValue,
    answer,
    form,
    value,
  } = props;

  useEffect(() => {
    setValue(answer ? answer.map((answer) => answer.id) : []);
  }, [answer]);

  const handleOnBlur = () => {
    if (onChange) {
      if (qnId) {
        onChange({ question_id: qnId, opted_answer_ids: value });
      } else {
        onChange(value);
      }
    }
  };

  const handleOnChange = (value) => {
    form.setFieldsValue({
      [qnId]: value,
    });
    setValue(value);
  };

  return (
    <Select
      className="login-input"
      mode="multiple"
      showSearch
      onSearch={() => {}}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      dropdownClassName="form-dropdown"
      placeholder={!selectField && placeholderText}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      value={value}
      bordered={false}
      disabled={disabled}
    >
      {options &&
        options.map((op, i) => (
          <Select.Option key={i} value={op.value || op.name}>
            {op.name}
          </Select.Option>
        ))}
    </Select>
  );
}
